import React from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TelegramShareButton,
} from "react-share";
import {
  EmailIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  TelegramIcon,
} from "react-share";
import styled from "styled-components";

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #F1F1F1;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

const ModalCloseButton = styled.button`
  position: absolute;
  background: none;
  border: none;
  margin: -10px 190px;
  font-size: 15px;
  cursor: pointer;

  @media(max-width:424px){
    margin: -10px 140px;
  }
`;

const ShareButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
`;

const ShareModal = ({ show, onClose, postKey }) => {
  if (!show) {
    return null;
  }

  const shareUrl = `${window.location.href}/posts/${postKey}`;

  return (
    <ModalBackground>
      <ModalContent>
        <ModalCloseButton onClick={onClose}>x</ModalCloseButton>
        <h3>Share this post</h3>
        <ShareButtonContainer>
          <EmailShareButton url={shareUrl}>
            <EmailIcon size={40} round />
          </EmailShareButton>
          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon size={40} round />
          </LinkedinShareButton>
          <TelegramShareButton url={shareUrl}>
            <TelegramIcon size={40} round />
          </TelegramShareButton>
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon size={40} round />
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl}>
            <TwitterIcon size={40} round />
          </TwitterShareButton>
          <WhatsappShareButton url={shareUrl}>
            <WhatsappIcon size={40} round />
          </WhatsappShareButton>
        </ShareButtonContainer>
      </ModalContent>
    </ModalBackground>
  );
};

export default ShareModal;
